<template>
  <el-form-item ref="elFormItemRef" :prop="prop" :label="i18nConfig(label)" :label-width="labelWidth">
    <slot></slot>
    <template #label="{ label }">
      <slot name="label" :label="label"></slot>
    </template>
    <template #error="{ error }">
      <slot name="error" :error="error">
      </slot>
    </template>
  </el-form-item>
</template>

<script>
import { i18nConfig } from '@/utils/ruoyi'
import { reactive, toRefs, watch } from 'vue'
export default {
  name: "gljy-form-item",
  emits: ["update:value"],
  props: {
    prop: {
      type: [String, Array]
    },
    label: String,
    labelPosition: String,
    labelWidth: {
      type: [String, Number]
    },
    required: Boolean,
    error: String,
    showMessage: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    inlineMessage: {
      type: [String, Boolean]
    },
    size: String,
    validateStatus: String
  },
  setup(props, context) {
    const elFormItemRef = ref();
    const datas = reactive({
      newValue: undefined,
      i18nConfig: i18nConfig
    })

    const methods = {
    }

    const exposesFunction = {
      size(size) {
        elFormItemRef.value.size(size);
      },
      validateMessage() {
        elFormItemRef.value.validateMessage()
      },
      validateState() {
        elFormItemRef.value.validateState()
      },
      validate() {
        elFormItemRef.value.validate()
      },
      resetField() {
        elFormItemRef.value.resetField()
      },
      clearValidate() {
        elFormItemRef.value.clearValidate()
      }
    }


    return {
      ...toRefs(datas),
      ...exposesFunction,
      elFormItemRef,
      ...methods
    }
  }
}
</script>

<style lang="scss" scoped></style>